module.exports = __webpack_public_path__ + "media/images/icon-bw-facebook@3x-5eae74c1838dadde726d25d078a0a704.png";